import html2canvas from "html2canvas";
import { useCallback } from "react";

export default function useCanvasShare({
  encarteName,
  shareText,
  canvasScale,
  setCanvasScale,
  setCanvasSelectedProductIndex,
  canvasTargetClassName,
  canShare,
  onBlockedShare,
}) {
  const shareCanvas = useCallback(async () => {
    if (!canShare) {
      onBlockedShare?.();
      return;
    }

    const previousScale = canvasScale;
    setCanvasSelectedProductIndex(null);
    setCanvasScale(3);

    await new Promise((resolve) => setTimeout(resolve, 0));

    const canvas = document.querySelector(`.${canvasTargetClassName}`);
    if (!canvas) {
      setCanvasScale(previousScale);
      await new Promise((resolve) => setTimeout(resolve, 100));
      return;
    }

    const pngCanvas = await html2canvas(canvas, {
      scale: 0.33333,
      logging: true,
      allowTaint: true,
      useCORS: true,
    });
    const userAgent = navigator.userAgent;
    const isIOS = /iPhone/gi.test(userAgent) || /iPad/gi.test(userAgent);
    const dataUrl = pngCanvas.toDataURL("image/jpeg", isIOS ? 1 : 0.7);

    const response = await fetch(dataUrl);
    const blob = await response.blob();
    if (blob.size > 10 * 1024 * 1024) {
      alert(
        "O arquivo é muito grande para compartilhar. Tente exportar para galeria em vez disso.",
      );
      setCanvasScale(previousScale);
      return;
    }

    const file = new File([blob], `${encarteName || "encarte"}.jpg`, {
      type: "image/jpeg",
    });

    setCanvasScale(previousScale);
    await new Promise((resolve) => setTimeout(resolve, 100));

    if (
      navigator.share &&
      navigator.canShare &&
      navigator.canShare({ files: [file] })
    ) {
      try {
        await navigator.share({
          title: encarteName || "Encarte",
          text: shareText || "Confira meu encarte!",
          files: [file],
        });
      } catch (err) {
        alert("Não foi possível compartilhar: " + err.message);
      }
    } else {
      alert("Compartilhamento nativo não suportado neste navegador.");
    }
  }, [
    canShare,
    canvasScale,
    canvasTargetClassName,
    encarteName,
    shareText,
    onBlockedShare,
    setCanvasScale,
    setCanvasSelectedProductIndex,
  ]);

  return { shareCanvas };
}
